<template>
  <v-dialog
    v-model="display"
    persistent
    transition="dialog-bottom-transition"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    :width="$store.state.common.largeDialogWidth"
  >
    <v-card>
      <v-card-title>
        <v-layout align-center>
          <div class="headline">
            <v-icon class="mr-2">
              textsms
            </v-icon>
            {{ $t('createTicker') }}
          </div>
          <v-btn
            class="ml-auto mr-0 my-0"
            :disabled="busy"
            flat
            icon
            :title="$t('cancel')"
            @click="emitAborted()"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-layout>
      </v-card-title>
      <!-- Preview -->
      <v-layout justify-center>
        <ticker-preview :message="message" />
      </v-layout>
      <v-card-text>
        <!-- Fields -->
        <v-layout column>
          <v-textarea
            ref="messageInput"
            v-model="message"
            rows="4"
            clearable
            :counter="messageLimit"
            :label="$t('message')"
            :rules="[rules.messageMin, rules.messageMax]"
            required
            @keyup.native.esc="emitAborted()"
            @keyup.native.ctrl.enter="emitSubmitted()"
          />
          <v-select
            v-show="uploadgroups.length > 1"
            v-model="selectedUploadGroupId"
            :items="uploadgroups"
            :label="$t('group')"
            :hint="$t('chooseUploadGroup') + '.'"
            persistent-hint
            item-text="name"
            item-value="id"
          />
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <btn-ok
          round
          :loading="busy"
          :disabled="!formIsValid"
          @click="emitSubmitted()"
        />
        <v-spacer />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import BtnOk from '@/components/ButtonOk';
import TickerPreview from '@/components/TickerPreview';

export default {
  name: 'CreateTickerDialog',
  components: {
    BtnOk,
    TickerPreview,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    uploadgroups: {
      type: Array[Object],
      required: true,
    },
  },
  data() {
    return {
      busy: false,
      display: this.show,
      selectedUploadGroupId: this.getInitialUploadgroupId(),
      message: '',
      messageLimit: 400,
      rules: {
        messageMin: (value) => {
          return (
            (value && value.trim().length > 0) || this.$t('messageTooShort')
          );
        },
        messageMax: (value) => {
          return (
            (value && value.length <= this.messageLimit) ||
            this.$t('messageTooLong')
          );
        },
      },
    };
  },
  computed: {
    formIsValid() {
      return (
        this.message.length > 0 &&
        this.message.length <= this.messageLimit &&
        this.selectedUploadGroupId !== null
      );
    },
  },
  watch: {
    /**
     * Update internal visibility flag when outter prop changes.
     */
    show: function (newVal) {
      this.display = newVal;

      if (this.display && this.$refs.messageInput) {
        this.$nextTick(() => {
          this.$refs.messageInput.focus();
        });
      }
    },
    message: function (message) {
      if (message === null) {
        this.message = '';
      }
    },
    /**
     * Communicate internal visibility change to outside world.
     */
    display: function (newVal) {
      this.$emit('toggled', newVal);
    },
    /**
     * It takes a moment to fetch the uploadgroups:
     * Make sure the group dropdown is updated.
     */
    uploadgroups(val) {
      if (!this.selectedUploadGroupId) {
        this.selectedUploadGroupId = this.getInitialUploadgroupId();
      }
    },
  },
  methods: {
    /**
     * We want to preselect the uploadgroup if there is only one, but
     * force the user to pick one himself explicitly if there are more.
     */
    getInitialUploadgroupId() {
      const numUploadGroups = this.uploadgroups.length;
      if (numUploadGroups === 0) {
        return null;
      } else if (numUploadGroups === 1) {
        const firstGroup = this.uploadgroups[0];
        return firstGroup.id;
      } else {
        // Multiple choices? Force user to pick one.
        return null;
      }
    },
    emitSubmitted() {
      if (!this.formIsValid) {
        return;
      }
      this.$emit('submitted', this.message, this.selectedUploadGroupId);
    },
    emitAborted() {
      this.$emit('aborted');
    },
    reset() {
      this.message = '';
      this.selectedUploadGroupId = this.getInitialUploadgroupId();
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/CreateTickerDialog.vue